module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-400.68797f52.svg";